import {html} from "./utils/environment";

console.log("Started JS App");

html.classList.add("is-loaded");
html.classList.add("is-ready");
html.classList.remove("is-loading");

// import table from "./components/table";

// table();
